<template>
  <maker-layout>
    <div>
      <v-row no-gutters align="center" class="content-header">
        <span class="font-weight-bold">Infos générales</span>
        <v-spacer></v-spacer>
        <v-btn class="n-white-btn n-small-btn px-2 mr-2" v-if="false">
          <v-icon>menu</v-icon>
        </v-btn>
      </v-row>
      <div class="page-main-content">
        <n-card class="px-6 pt-6 pb-4">
          <v-alert dense text outlined type="info" class="text-left" v-if="!canUpdateInfos">
            Ce prestataire gère lui-même ces informations
          </v-alert>
          <v-row justify="center" align="center">
            <v-col cols="12">
              <v-text-field v-model="maker.name" label="Nom" outlined hide-details required autofocus :disabled="!canUpdateInfos" />
            </v-col>
          </v-row>
          <v-row justify="center" align="center">
            <v-col cols="12">
              <v-text-field v-model="maker.address" label="Adresse" outlined hide-details required :disabled="!canUpdateInfos" />
            </v-col>
          </v-row>
          <v-row justify="center" align="center">
            <v-col cols="4">
              <v-text-field v-model="maker.postalCode" label="Code Postal" outlined hide-details required :disabled="!canUpdateInfos" />
            </v-col>
            <v-col cols="8">
              <v-text-field v-model="maker.city" label="Ville" outlined hide-details required :disabled="!canUpdateInfos" />
            </v-col>
          </v-row>
          <v-col align="right" class="px-0" v-if="canUpdateInfos">
            <v-btn :disabled="!$canWrite" dark color="primary" elevation="0" @click="$canWrite && (save($event))">Enregistrer</v-btn>
          </v-col>
        </n-card>
        <div class="text-left font-weight-bold pt-6 pb-4">Tags assignés</div>
        <n-card class="px-6 pt-6 pb-4">
          <v-row no-gutters justify="center" align="center" v-if="isFetchingTags">
            <v-progress-linear
              indeterminate
              color= "primary"
              height="5"
              style="width: 200px;"
              class="my-5"
              v-if="isFetchingTags"
            />
          </v-row>
          <v-row no-gutters justify="start" align="center" v-else>
            <tag-chip v-for="tag in tags" :key="tag.id" :tag="tag" @remove="unassignTag" removable />
            <v-menu
              v-model="isShowingTagsList"
              min-width="350"
              :close-on-content-click="false"
              offset-y
              bottom
            >
              <template v-slot:activator="{ on, attrs }">
                <v-chip
                  color="grey"
                  small
                  outlined
                  class="my-1 mx-1"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon small left class="mr-1">add</v-icon>
                  Ajouter un tag
                </v-chip>
              </template>
              <tags-menu-list
                :client-id="company.id"
                :excluded-tags="tags"
                @selected="tagSelected"
                v-if="isShowingTagsList"
              />
            </v-menu>
          </v-row>
        </n-card>
      </div>
    </div>
  </maker-layout>
</template>

<script>
import _ from 'lodash';
import { mapActions, mapState } from 'vuex';
import MakerLayout from '@/views/settings/makers/MakerLayout.vue';
import TagsMenuList from '@/components/Tags/MenuList.vue';
import TagChip from '@/components/Tags/Chip.vue';

export default {
  data: () => ({
    maker: {},
    isShowingTagsList: false,
  }),
  computed: {
    ...mapState(`model/client`, [
      `company`,
    ]),
    ...mapState(`ui/settingsMakers`, [
      `isFetchingTags`,
      `tags`,
    ]),
    ...mapState(`ui/settingsMakers`, {
      storeCurrentAdminMaker: state => _.cloneDeep(state.currentAdminMaker),
    }),
    canUpdateInfos() {
      return this.maker?.slug === ``;
    },
  },
  watch: {
    storeCurrentAdminMaker(newValue) {
      this.maker = newValue;
    },
  },
  methods: {
    ...mapActions(`ui/settingsMakers`, [
      `fetchTags`,
      `assignTag`,
      `unassignTag`,
    ]),
    async save() {
      await this.$store.dispatch(`model/client/saveMaker`, { maker: this.maker });
      this.$store.dispatch(`ui/settingsMakers/fetchCurrentAdminMaker`, this.maker.id);
      this.$store.dispatch(`showSnackbar`, {
        color: `success`,
        message: `Prestataire modifié avec succès`,
      });
    },
    tagSelected(tag) {
      this.isShowingTagsList = false;
      this.assignTag(tag);
    },
  },
  beforeMount() {
    this.maker = this.storeCurrentAdminMaker || {};
    this.fetchTags();
  },
  components: {
    MakerLayout,
    TagsMenuList,
    TagChip,
  },
};
</script>

<style lang="scss">
</style>
